//angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormControl } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DeviceDetectorService } from 'ngx-device-detector';
//app
import { RestResponse } from '../../../../../../_shared/models';
import { CompanyNotificationTemplate } from 'src/app/_shared/models/notifications.model';
import { AppAnimations } from '../../../../../../_shared/animations';
import { VisibleState, LoadingState, NotificationSectionValues } from 'src/app/app.data';
import { SettingsService } from '../../../_services/api/settings.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', 'class': 'templates' }
})

export class TemplatesComponent implements OnInit, OnDestroy {
  templateId: number;
  template: CompanyNotificationTemplate;
  formFromSubmitted: boolean = false;
  formFromEditVisible: boolean = false;
  formSubject: FormGroup;
  formRecipients: FormGroup;
  formSubjectSubmitted: boolean = false;
  formSubjectVisible: boolean = false;
  isMobile: boolean;
  resSuccess: boolean = true;
  statusSpinnerFormFrom: LoadingState;
  statusSpinnerFormSubject: LoadingState;
  statusSpinnerFormRecipients: LoadingState;
  statusFormFrom: VisibleState;
  statusFormFromEdit: VisibleState;
  statusFormSubject: VisibleState;
  statusFormRecipients: VisibleState;
  statusFormSubjectEdit: VisibleState;
  statusFormRecipientsEdit: VisibleState;
  notificationSectionKeyName: NotificationSectionValues;
  private subs = new Unsubscriber();

  emailAddressLabel: string = 'Email Address';
  nameLabel: string = 'Name';
  previewTextLabel: string = 'PreviewText';
  subjectLabel: string = 'Subject';
  ccLabel: string = 'CC: ___________';
  bccLabel: string = 'BCC: ___________';
  isFormReady:boolean = false;

  constructor(
    private _deviceService: DeviceDetectorService,
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
  ) {
    this.subs.addSub = this._route.params.subscribe((params) => {
      this.notificationSectionKeyName = params['notificationSectionKeyName'];
    });
    this.subs.addSub = this._route.params.subscribe((params) => {
      this.templateId = params['id'];
    });

    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-bullet', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-bullet-01.svg'));
    this._iconRegistry.addSvgIcon('ico-disabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-03.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-02.svg'));
    this._iconRegistry.addSvgIcon('ico-enabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-05.svg'));
    this._iconRegistry.addSvgIcon('ico-error', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-error-02.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-preview', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-wizard-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-switch', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-01.svg'));
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));
    this._iconRegistry.addSvgIcon('ico-loader', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));

    this.isMobile = this._deviceService.isMobile();

    this.formSubject = new FormGroup({
      subject: new FormControl(''),
      previewText: new FormControl(''),
    });

    this.formRecipients = new FormGroup({
      cc: new FormControl(''),
      bcc: new FormControl(''),
    });

    this.statusSpinnerFormFrom = LoadingState.isLoaded;
    this.statusSpinnerFormSubject = LoadingState.isLoaded;
    this.statusSpinnerFormRecipients = LoadingState.isLoaded;
    this.statusFormFrom = VisibleState.isVisible;
    this.statusFormFromEdit = VisibleState.isHidden;
    this.statusFormSubject = VisibleState.isVisible;
    this.statusFormRecipients = VisibleState.isVisible;
    this.statusFormSubjectEdit = VisibleState.isHidden;
    this.statusFormRecipientsEdit = VisibleState.isHidden;
  }

  ngOnInit() {
    this.getTemplateById(this.templateId);
  }

  getTemplateById(_templateId) {
    this.subs.addSub = this.settingsService.getTemplateByTemplateId(_templateId)
      .subscribe(
        (res: RestResponse) => {
          this.template = <CompanyNotificationTemplate>res.data;
          this.isFormReady = true;
        },
        (err: RestResponse) => {
          this.isFormReady = true;
          this._meta.showNotification(err);
        }
      );
  }

  updateTemplate(_templateId, _formName, _values) {
    this.subs.addSub = this.settingsService.updateTemplateByTemplateId(_templateId, _values)
      .subscribe(
        (res: RestResponse) => {
          this.template = <CompanyNotificationTemplate>res.data;
          this[`statusSpinnerForm${_formName}`] = LoadingState.isLoaded;
          this[`form${_formName}EditVisible`] = false;
          this[`statusForm${_formName}`] = VisibleState.isVisible;
          this.resetForm(_formName);
          this._meta.showNotification(res);
        },
        (err: RestResponse) => {
          this[`statusSpinnerForm${_formName}`] = LoadingState.isLoaded;
          this[`form${_formName}EditVisible`] = false;
          this[`statusForm${_formName}`] = VisibleState.isVisible;
          this.resetForm(_formName);
          this._meta.showNotification(err);
        }
      );
  }

  resetForm(_formName: string) {
    this[`form${_formName}`].reset();
    Object.keys(this[`form${_formName}`].controls).forEach(key => {
      this[`form${_formName}`].get(key).setErrors(null);
    });
  }

  handleForm(_formName: string, _form) {
    _form.patchValue(this.template);
    this[`form${_formName}EditVisible`] = !this[`form${_formName}EditVisible`];
    this[`statusForm${_formName}Edit`] = this[`form${_formName}EditVisible`] ? VisibleState.isVisible : VisibleState.isHidden;
    this[`statusForm${_formName}`] = !this[`form${_formName}EditVisible`] ? VisibleState.isVisible : VisibleState.isHidden;
  }

  onSubmit(_formName: string, _form) {
    if (_form.valid) {
      this[`statusSpinnerForm${_formName}`] = LoadingState.isLoading;
      this[`statusForm${_formName}Edit`] = VisibleState.isHidden;
      this[`form${_formName}Submitted`] = !this[`form${_formName}Submitted`];
      this.updateTemplate(this.templateId, _formName, _form.value);
    }
  }

  cancelForm(_formName: string, _form) {
    this.resetForm(_formName);
    this[`form${_formName}Submitted`] = false;
    this[`form${_formName}EditVisible`] = false;
    this[`statusForm${_formName}Edit`] = VisibleState.isHidden;
    this[`statusForm${_formName}`] = VisibleState.isVisible;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
